import type { SchedulePublishStatusChipVariant } from '../../../../../features/schedule/scheduleSelectors';

type SchedulePublishStatusChipProps = {
  variant: SchedulePublishStatusChipVariant;
  label: string;
  timeLabel?: string | null;
};

const variantClass: Record<SchedulePublishStatusChipVariant, string> = {
  warning: 'text-bg-warning',
  success: 'text-bg-success',
  neutral: 'text-bg-secondary',
};

export function SchedulePublishStatusChip({
  variant,
  label,
  timeLabel,
}: SchedulePublishStatusChipProps) {
  if (!label) return null;

  return (
    <span
      className={`badge schedule-toolbar__status-chip ${variantClass[variant]}`}
      role="status"
    >
      <span className="schedule-toolbar__status-chip-label">{label}</span>
      {timeLabel ? (
        <span className="schedule-toolbar__status-chip-time d-none d-xl-inline">
          {' · '}
          {timeLabel}
        </span>
      ) : null}
    </span>
  );
}
